<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Members</h1>
		<div class="content-wrapper">
			<div class="single-text-wrapper">
				<b-field label="Member ID (Leave blank to export all)">
					<b-input v-model="card_number" placeholder="Member ID" @keyup.native.enter="getSyncChanges()"></b-input>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit">SUBMIT</div>
				<br />
				<div class="big-button" @click="check">CHECK</div>
			</div>

			Points check
			<div v-for="(member, index) of checkData" :key="index">
				{{ member.card_number }} point is {{ member.points }}. Reward point is {{ member.amount }}
			</div>

			Reject Order Data
			<div v-for="(member, index) of rejectData" :key="index">
				{{ member.card_number }} point is {{ member.points }}. Reward point is {{ member.amount }}
			</div>
		</div>
	</div>
</template>

<script>
// import { bdBrands } from '@/data/brands.js'

export default {
	name: 'ExportMembers',
	data: () => ({
		isLoading: false,
		card_number: null,
		checkData: [],
		rejectData: []
	}),

	methods: {
		submit: async function() {
			if (this.card_number == null) {
				await this.export_all_members()
			} else {
				await this.export_member()
			}
		},

		async check() {
			this.isLoading = true
			this.members = []

			var data = {}

			// For getting total value of sales
			data = {
				limit: 1000
			}

			const getMembers = await this.$api.getMembers({ data })

			if (!getMembers) {
				return
			}

			getMembers.data.list.map(data => {
				this.members.push(data)
			})

			if (getMembers.data.total > 1000) {
				let totalLoop = Math.ceil(getMembers.data.total / 1000)

				var i
				var skip

				// Loop all the pagers
				for (i = 1; i < totalLoop; i++) {
					skip = i * 1000

					data.skip = skip

					const result = await this.$api.getMembers({ data })

					if (result) {
						result.data.list.map(data => {
							this.members.push(data)
						})
					}
				}
			}

			for (const member of this.members) {
				if (member.points < -1000) {
					// Get user history
					data = {
						member: {
							id: member._id
						},
						sort: {
							createdAt: 'asc'
						},
						limit: 1000
					}

					member.amount = 0

					const getMemberHistory = await this.$api.getMemberHistory({ data })

					const timeArray = []

					member.foundDuplicate = false

					if (getMemberHistory && getMemberHistory.data.total > 0) {
						for (const memberHistory of getMemberHistory.data.list) {
							if (timeArray.legnth < 1) {
								timeArray.push(this.$moment(memberHistory.createdAt).format('DD/MM/YYYY HH:mm'))
							} else {
								const rewardTime = this.$moment(memberHistory.createdAt).format('DD/MM/YYYY HH:mm')

								if (timeArray.includes(rewardTime)) {
									if (memberHistory.member.rewards_items[0]) {
										member.foundDuplicate = true

										data = {
											id: memberHistory.member.rewards_items[0]
										}

										const rewardDetail = await this.$api.getRewardDetail({ data })

										member.amount = rewardDetail.data.points
									}
								} else {
									timeArray.push(rewardTime)
								}
							}
						}
					}

					if (member.foundDuplicate) {
						this.checkData.push(member)
					} else {
						this.rejectData.push(member)
					}
				}
			}

			this.isLoading = false
		},

		async export_member() {
			this.isLoading = true
			const card_number = this.card_number

			let data = {
				card_number,
				limit: 1000
			}

			const getMember = await this.$api.getMembers({ data })

			if (getMember.data.count == 0) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Data not found.'
				})
				this.isLoading = false
				return
			}

			const member_id = getMember.data.list[0]._id

			// Load member histories
			data = {
				member: {
					id: member_id
				},
				sort: {
					createdAt: 'asc'
				},
				limit: 1000
			}

			const getMemberHistory = await this.$api.getMemberHistory({ data })

			if (!getMemberHistory.data) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Data not found.'
				})
				this.isLoading = false
				return
			}

			const histories = []

			for (const history of getMemberHistory.data.list) {
				history.memberHistory = true
				histories.push(history)
			}

			if (!histories) {
				return
			}

			// Load member reward histories
			data = {
				member: member_id,
				limit: 5000,
				populate: ['member', 'shop', 'reward', 'product']
			}

			const getRewards = await this.$api.getRewards({ data })

			if (getRewards) {
				for (const history of getRewards.data.list) {
					history.rewardHistory = true
					histories.push(history)
				}
			}

			histories.sort(function(a, b) {
				return a.createdAt < b.createdAt ? -1 : a.createdAt == b.createdAt ? 0 : 1
			})

			let finalData = ''

			finalData += 'NAME, CARD NUMBER, POINTS EARNED, TOTAL POINTS, ORDER ID, TYPE, DATE\r\n'

			// total_products.map(p => {
			for (const history of histories) {
				let toAdd = []

				if (history.memberHistory) {
					const member = history.member

					let type = null

					if (history.order_id != 'unknown' && history.type == 'point_expired') {
						type = 'Point Expired'
					} else if (history.order_id != 'unknown') {
						type = 'Sales'
					} else {
						type = '-'
					}

					toAdd = [
						'"' + member.name + '"',
						'"' + member.card_number + '"',
						history.points ? history.points : 0,
						member.points ? member.points : 0,
						history.order_id == 'unknown' ? '-' : history.order_id,
						type,
						this.$moment(history.createdAt).format('DD/MM/YYYY HH:mm')
					]
				}

				if (history.rewardHistory) {
					const member = history.member

					toAdd = [
						'"' + member.name + '"',
						'"' + member.card_number + '"',
						'-',
						'-',
						history.order_id == 'unknown' ? '-' : history.order_id,
						'Reward Withdrawal',
						this.$moment(history.createdAt).format('DD/MM/YYYY HH:mm')
					]
				}

				let row = toAdd.join(',')

				finalData += row + '\r\n'
			}

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Member_' + this.card_number + '.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		async export_all_members() {
			this.isLoading = true
			this.members = []

			var data = {}

			// For getting total value of sales
			data = {
				limit: 1000
			}

			const getMembers = await this.$api.getMembers({ data })

			if (!getMembers) {
				return
			}

			getMembers.data.list.map(data => {
				this.members.push(data)
			})

			if (getMembers.data.total > 1000) {
				let totalLoop = Math.ceil(getMembers.data.total / 1000)

				var i
				var skip

				// Loop all the pagers
				for (i = 1; i < totalLoop; i++) {
					skip = i * 1000

					data.skip = skip

					const result = await this.$api.getMembers({ data })

					if (result) {
						result.data.list.map(data => {
							this.members.push(data)
						})
					}
				}
			}

			let finalData = ''

			finalData += 'NAME, CARD NUMBER, NRC, ADDRESS, PHONE, DATE OF BIRTH, GENDER, POINTS, REGISTERED DATE\r\n'

			// total_products.map(p => {
			for (const member of this.members) {
				const toAdd = [
					'"' + member.name + '"',
					'"' + member.card_number + '"',
					member.nrc,
					'"' + member.address + '"',
					member.mobile_phone,
					'"' + member.dob + '"',
					member.gender,
					member.points,
					this.$moment(member.createdAt).format('DD/MM/YYYY')
				]

				let row = toAdd.join(',')

				finalData += row + '\r\n'
			}

			var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Members.csv')
			document.body.appendChild(link) // Required for FF

			this.isLoading = false

			link.click()
			link.remove()
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YYYY hh:mm A')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
